import BigTerms from "../../components/legal/BigTerms"

export default function Terms(props) {

    return (
        <div className={props.container}>
            <div className="bg-white-900 dark:bg-white-900 w-full">
                <div className="items-center px-16 py-8 my-10 mx-auto w-fit py-0">
                    <div className="flex bg-white rounded-lg shadow px-16 py-16 dark:border">
                        <BigTerms></BigTerms>
                    </div>
                </div>
            </div>
        </div>
    )
}